import WarningIcon from '@mui/icons-material/Warning';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';
import variable from '../shared/style/variable';
import { cleanAlert } from '../store/alert/alertSlice';
import { useAppDispatch } from '../store/hook';
import { cleanProject } from '../store/project/projectSlice';
import { cleanResult } from '../store/result/resultSlice';
import { cleanEngine } from '../store/engine/engineSlice';
import { cleanMap } from '../store/map/mapSlice';

const ErrorBoundary = () => {
    let error = useRouteError();
    console.log(error);

    const { t } = useTranslation();

    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(cleanProject());
        dispatch(cleanResult());
        dispatch(cleanEngine());
        dispatch(cleanMap());
        dispatch(cleanAlert());
    }, []);

    return (
        <Stack direction={'column'} margin={'4rem 0'} alignItems={'center'} spacing={2}>
            <WarningIcon style={{ height: '5rem', width: '5rem', fill: variable.red }} />
            <Typography variant='h1' style={{ color: variable.green }} gutterBottom>
                {t('oopSomethingWentWrong')}
            </Typography>
        </Stack>
    );
};

export default ErrorBoundary;
